import React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import axios from 'axios';
import { connect } from "react-redux";
import PantallaCarga from "../mensajeFlash/PantallaCarga";
import { authenticateUser, authenticateUserKeycloak } from "./SesionService";
import { validateForm } from "./../../constans/validationUtils";
import { URL } from "../../constans/constants";
import mirecibo_logo from "../../assets/images/mirecibo-logo.svg";
import logo_gplay from "../../assets/images/google-play-icon.svg";
import logo_appstore from "../../assets/images/app-store-icon.svg";
import img_login from "../../assets/images/ilustraciones/img-login.svg";
import { showhidePassword } from '../../assets/js/scripts/showhidepassword';
import '../../assets/styles/alert-login.css';

class LoginKeicloack extends React.Component {
  constructor(props) {
    super(props);
    const savedAttempts = parseInt(localStorage.getItem("failedAttempts"), 10) || 0;
    const params = new URLSearchParams(this.props.location.search);
    const sesionCaducada = params.get('sesionCaducada') === 'true';
    this.state = {
      username: "",
      password: "",
      errors: {
        username: null,
        password: null
      },
      mostrarMensaje: false,
      mensaje: "",
      openPantallaCarga: false,
      failedAttempts: savedAttempts,
      showCaptcha: savedAttempts >= 3,
      captchaToken: "",
      captcha: false,
      token: "",
      isAnimatingOut: false,
      sesionCaducada: sesionCaducada
    };
  }

  reglasValidacionCampos = {
    username: [
      { required: true, message: 'Ingrese un nombre de usuario' },
    ],
    password: [
      { required: true, message: 'Ingrese una contraseña' },
    ]
  };

  handleInput = (e) => {
    let name = e.target.name;
    let val = e.target.value;
    this.setState(prevState => ({
      errors: {
        ...prevState.errors,
        [name]: null
      },
      [name]: val,
    }));
  };

  handleCaptchaChange = (token) => {
    this.setState({ captchaToken: token });
  };

  handleAuthentication = (event) => {
    event.preventDefault();
    const { isValid, errors } = validateForm(this.state, this.reglasValidacionCampos);

    if (isValid) {
      if (this.state.showCaptcha && !this.state.captchaToken) {
        this.setState({ mostrarMensaje: true, mensaje: "Por favor complete el CAPTCHA." });
        return;
      }

      this.setState({ openPantallaCarga: true });

      const json = {
        username: this.state.username,
        password: this.state.password,
        captchaToken: this.state.captchaToken,
      };

      this.props.authenticateUserKeycloak(json).then((respuesta) => {
        if (respuesta != null) {
          if (respuesta.error) {
            let newAttempts = 0;
            if (this.state.captcha) {
              newAttempts = this.state.failedAttempts + 1;
            }
            this.setState(prevState => ({
              mostrarMensaje: true,
              mensaje: respuesta.mensaje,
              openPantallaCarga: false,
              failedAttempts: newAttempts,
              showCaptcha: newAttempts >= 3
            }));
            localStorage.setItem("failedAttempts", newAttempts);
          } else {
            this.setState({ mostrarMensaje: false, failedAttempts: 0, showCaptcha: false });
            localStorage.removeItem("failedAttempts");
          }
        }
      });
    } else {
      this.setState({ errors: errors });
    }
  };


  componentDidMount() {
    showhidePassword();
    if(this.state.sesionCaducada){
      this.setState({mostrarMensaje: true, mensaje: "Su sesion ha caducado, debe volver a iniciar sesion"})
    }
    axios.get(URL + 'seguridad/captcha')
      .then(response => {
        if (!response.data.error) {
          const datos = response.data.datos;
          const captchaValue = datos.find(item => item.nombre === "captcha")?.valor || "false";
          const captchaTokenValue = datos.find(item => item.nombre === "captchaToken")?.valor || "";

          localStorage.setItem("captcha", captchaValue);
          localStorage.setItem("captchaToken", captchaTokenValue);

          this.setState({
            captcha: captchaValue === "true",
            token: captchaTokenValue
          });
        }
      })
      .catch(error => {
        console.error("Error al obtener el captcha:", error);
      });
  }

  handleCloseMensajeError = (e) => {

    e.preventDefault();
    e.stopPropagation();

    this.setState({ isAnimatingOut: true });

    setTimeout(() => {
      this.setState({
        mostrarMensaje: false,
        isAnimatingOut: false
      });
    }, 300);
  }

  render() {

    const alertClasses = `component-alert-callout alert-error ${this.state.isAnimatingOut ? 'fade-out' : 'fade-in'}`;

    return (
      <div>

        <div className="template-base template-login theme-ligth">
          <div className="wrapperLogin container-flex">
            <div className="col content-login">
              <div className="content-form container-sm">
                <img src={mirecibo_logo} className="img-fluid brand" alt="Logotipo MIRECIBO" />
                <form noValidate onSubmit={this.handleAuthentication} className="form">
                  <h1 className="section__title"> Bienvenido a MiRecibo </h1>
                  <p className="section__description"> Gestiona y administra documentos entre colaboradores y RRHH </p>
                  <div className="form-group">
                    <input type="text" name="username" className="form-input" placeholder="" onChange={this.handleInput} value={this.state.username} />
                    <label htmlFor="text" name="username" className="form-label"> Nombre de usuario </label>
                  </div>
                  <div className="form-group group-icon">
                    <input type="password" name="password" className="form-input" placeholder="Ingresar contraseña actual" onChange={this.handleInput} value={this.state.password} />
                    <label htmlFor="actual-password" className="form-label"> Password </label>
                    <button className="input-icon toggle-password" type="button"> <span className="material-symbols-outlined"> visibility </span> </button>
                  </div>
                  {this.state.showCaptcha && (
                    <div className="captcha-container">
                      <ReCAPTCHA
                        sitekey={localStorage.getItem("captchaToken")}
                        onChange={this.handleCaptchaChange}
                      />
                    </div>
                  )}
                  {
                    this.state.mostrarMensaje &&
                    <div className={alertClasses}>
                      <span className="material-symbols-outlined">error</span>
                      <div className="alret-caption">
                        <p className="alert-txt"> {this.state.mensaje} </p>
                      </div>
                      <button type='button' className="close-alert" onClick={this.handleCloseMensajeError}> <span className="material-symbols-outlined"> close </span> </button>
                    </div>
                  }
                  <button type="submit" className="btn-large btn-primary"> INGRESAR </button>
                </form>
                {/*<div className="stores-access">*/}
                {/*  <p className="section__description"> También está disponible para tu móvil, descarga la app desde aquí </p>*/}
                {/*  <div className="stores">*/}
                {/*    <a href="https://play.google.com/store/apps/details?id=isaltdapy.mireciboapp&pcampaignid=web_share" className="store-link" target="_blank" rel="noopener noreferrer">*/}
                {/*      <img src={logo_gplay} alt="Disponible en Google Play" />*/}
                {/*    </a>*/}
                {/*    <a href="https://apps.apple.com/us/app/mi-recibo-app/id6747207782" className="store-link" target="_blank" rel="noopener noreferrer">*/}
                {/*      <img src={logo_appstore} alt="Disponible en App Store" />*/}
                {/*    </a>*/}
                {/*  </div>*/}
                {/*</div>*/}
              </div>
              <div className="poweredby"> <span> Producto desarrollado por <a href="https://www.interfase.global/">Interfase </a></span></div>
            </div>
            <div className="col content-illustration">
              <img src={img_login} className="img-fluid" alt="Ilustracion Login" />
            </div>
          </div>
          <PantallaCarga open={this.state.openPantallaCarga} mensaje="Iniciando sesión" />
        </div>
      </div>

    );
  }
}

const mapStateToProps = (state) => ({
  sessionData: state.sessionData,
});

const mapDispatchToProps = (dispatch) => ({
  authenticateUser: (value) => dispatch(authenticateUser(value)),
  authenticateUserKeycloak: (value) => dispatch(authenticateUserKeycloak(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginKeicloack);